import React from "react";
import StewartInput from "controls/global/stewart-input";
import InputSearchAdornment from "pages/myFiles/components/input-search/InputSearchAdornment";
import { useDateRangeFilterStatus, useGlobalAccess, useSearchColumnToggle } from "utils/context/GlobalAccessContext";

interface Props<T> {
  handleFilterChange: (
    name: keyof T,
    value: any,
    execSearch: boolean
  ) => void;
  value: any;
}

const KeywordSearchField = <T extends object>({ handleFilterChange, value }: Props<T>) => {
  const [, { setHasStartedTyping }] = useGlobalAccess();
  const [{isSearchColumnOn}] = useSearchColumnToggle();
  const [{dateRangeFilterStarted},] = useDateRangeFilterStatus();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value ? event.target.value : undefined;
    if (newValue && newValue.trim().length > 0) {
      setHasStartedTyping(true);
    } else {
      setHasStartedTyping(false);
    }
    const startSearching = newValue ? newValue.length > 2 : true;
    handleFilterChange("keyword" as keyof T, newValue, startSearching);
  };

  return (
    <StewartInput
      data-test="keywordSearch"
      fullWidth
      placeholder="Keyword Search"
      InputProps={{
        disableUnderline: true,
        endAdornment: <InputSearchAdornment />,
      }}
      variant="outlined"
      InputLabelProps={{ shrink: true }}
      onChange={handleChange}
      value={value}
      disabled={isSearchColumnOn || dateRangeFilterStarted}
    />
  );
};

export default KeywordSearchField;
